import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('devicePanic', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DevicePanicService.js